import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { CreditService } from '../../services/credit/credit.service';
import { CreditDetailAgence, CreditTypeCredit } from '../../interfaces/credit.interface';
import { etatListeDepuisParams, filtreActif } from '../../utils/dashboard-filtre-url';

export interface DetailAgenceCreditResolvedData {
  detail: CreditDetailAgence;
  typesCredit: CreditTypeCredit[];
}

/**
 * Les filtres vivent dans les query params : la résolution rejoue directement la
 * recherche, sinon un retour sur la page afficherait la liste complète avant que
 * le composant ne refasse l'appel filtré.
 */
export const detailAgenceCreditResolver: ResolveFn<DetailAgenceCreditResolvedData> = (
  route: ActivatedRouteSnapshot,
) => {
  const code = route.paramMap.get('code')!;
  const { filtre, page, perPage } = etatListeDepuisParams(route.queryParamMap);
  const svc = inject(CreditService);
  return forkJoin({
    detail: filtreActif(filtre)
      ? svc.filtrerDetailAgence(code, filtre, page, perPage)
      : svc.getDetailAgence(code, page, perPage),
    typesCredit: svc.getTypesCredit(),
  });
};
